import { useAppSelector } from '@hooks/reduxHooks';
import { $api } from '@service/RequestService';
import { timeStampToDate } from '@utils/index';
import { useQuery } from 'react-query';

import { offerModels } from '..';

export function useOneOffer(payloadId?: number) {
  const id = useAppSelector(
    ({
      offerReducer: {
        view: { id }
      }
    }) => id
  );

  const { data, ...arg } = useQuery<{ offer: offerModels.OfferType }>(
    ['one-realtor-offer', payloadId || id],
    async () => {
      const { data } = await $api.get(`/v1/offer/${payloadId || id}`);

      const offer: offerModels.OfferType = data?.data;

      return {
        offer: offer
          ? {
            ...offer,
            cratedDate: timeStampToDate({ date: offer?.cratedDate, timeStamp: offer?.cratedTimestamp }),
            updateDate: timeStampToDate({ date: offer?.updateDate, timeStamp: offer?.updateTimestamp })
          }
          : offer
      };
    },
    {
      retry: false,
      enabled: !!(payloadId || id)
    }
  );

  return { ...data, ...arg };
}
